import { useCallback, useEffect, useState } from "react";

const useHttp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (url) => {
    setLoading(true);
    console.log("API CALLED");
    try {
      const response = await fetch(
        "https://youtube-v31.p.rapidapi.com/" + url + "&maxResults=50",
        {
          method: "GET",
          headers: {
            "X-RapidAPI-Key": process.env.REACT_APP_RAPID_API_KEY,
            "X-RapidAPI-Host": "youtube-v31.p.rapidapi.com",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error Fetching Data");
      }

      const data = await response.json();
      setError(null);
      return data;
    } catch (error) {
      setError(error.message);
    }
    setLoading(false);
  }, []);

  return { sendRequest, loading, error };
};

export default useHttp;
